import { render, staticRenderFns } from "./ListaProyectos.vue?vue&type=template&id=1cdb2ae4&"
import script from "./ListaProyectos.vue?vue&type=script&lang=js&"
export * from "./ListaProyectos.vue?vue&type=script&lang=js&"
import style0 from "./ListaProyectos.vue?vue&type=style&index=0&id=1cdb2ae4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports